import React from 'react';
import { FadeIn } from '../animations/FadeIn';
import SafeIcon from '../../common/SafeIcon';

export const Privacy = () => {
  return (
    <section id="privacy" className="py-24 bg-paper">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-ink rounded-[32px] p-10 md:p-16 text-white relative overflow-hidden">
          {/* Subtle gradient accent */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-wave-gradient rounded-full blur-[120px] opacity-20"></div>
          
          <div className="relative z-10">
            <SafeIcon name="Shield" className="text-4xl text-mint mb-8" />
            <FadeIn>
              <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-6">Your health data is yours.</h2>
              <p className="text-lg text-white/70 font-light leading-relaxed mb-8 max-w-2xl">
                We believe tracking your health shouldn't cost you your privacy. Curve is built with a fundamentally different architecture than most health apps.
              </p>
            </FadeIn>

            <div className="grid sm:grid-cols-2 gap-8 mt-12">
              <FadeIn delay={0.1}>
                <h4 className="font-semibold text-lg mb-2 flex items-center gap-2">
                  <SafeIcon name="HardDrive" className="text-sky" />
                  On-device storage
                </h4>
                <p className="text-white/60 font-light text-sm leading-relaxed">
                  All your logs, weights, and notes live strictly on your phone. We don't have servers storing your personal data.
                </p>
              </FadeIn>
              <FadeIn delay={0.2}>
                <h4 className="font-semibold text-lg mb-2 flex items-center gap-2">
                  <SafeIcon name="UserX" className="text-mint" />
                  No sign-up needed
                </h4>
                <p className="text-white/60 font-light text-sm leading-relaxed">
                  Download and start using immediately. No email, no password, no linking to social accounts.
                </p>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};